import client from './client';
import type { AxiosProgressEvent } from 'axios';

export interface VideoUploadResponse {
  id: string;
  original_filename: string;
  file_size: number;
  mime_type: string;
  status: string;
  created_at: string;
}

export interface VideoStatusResponse {
  id: string;
  status: string;
  duration_seconds: number | null;
  width: number | null;
  height: number | null;
  error_message: string | null;
  updated_at: string;
}

export interface VideoListItem {
  id: string;
  original_filename: string;
  status: string;
  duration_seconds: number | null;
  created_at: string;
}

export interface VideoListResponse {
  videos: VideoListItem[];
  total: number;
}

/**
 * Carica un video con progresso opzionale.
 */
export async function uploadVideo(
  file: File,
  onProgress?: (progress: number) => void
): Promise<VideoUploadResponse> {
  const formData = new FormData();
  formData.append('file', file);

  const response = await client.post<VideoUploadResponse>('/videos/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (event: AxiosProgressEvent) => {
      if (onProgress && event.total) {
        const percent = Math.round((event.loaded * 100) / event.total);
        onProgress(percent);
      }
    },
  });
  return response.data;
}

/**
 * Recupera lo stato di elaborazione di un video.
 */
export async function getVideoStatus(videoId: string): Promise<VideoStatusResponse> {
  const response = await client.get<VideoStatusResponse>(`/videos/${videoId}/status`);
  return response.data;
}

/**
 * Elenca i video caricati.
 */
export async function listVideos(
  skip: number = 0,
  limit: number = 20
): Promise<VideoListResponse> {
  const response = await client.get<VideoListResponse>('/videos/', {
    params: { skip, limit },
  });
  return response.data;
}

/**
 * Elimina un video e i dati associati.
 */
export async function deleteVideo(videoId: string): Promise<void> {
  await client.delete(`/videos/${videoId}`);
}